import { render, staticRenderFns } from "./moneyTextBoard.vue?vue&type=template&id=6864638d&scoped=true"
import script from "./moneyTextBoard.vue?vue&type=script&lang=js"
export * from "./moneyTextBoard.vue?vue&type=script&lang=js"
import style0 from "./moneyTextBoard.vue?vue&type=style&index=0&id=6864638d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864638d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6864638d')) {
      api.createRecord('6864638d', component.options)
    } else {
      api.reload('6864638d', component.options)
    }
    module.hot.accept("./moneyTextBoard.vue?vue&type=template&id=6864638d&scoped=true", function () {
      api.rerender('6864638d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/moneyTextBoard.vue"
export default component.exports